export const DEFAULT_QUERY_BUSTER_KEY = 'DEFAULT_QUERY_BUSTER_KEY'
